module.exports = __webpack_public_path__ + "static/media/stop-circle.7290c06a.svg";